module.exports = __webpack_public_path__ + "img/Caminho4274.ac5aebb7.svg";